import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Interfaces
interface Features {
    title?: string;
    description?: string;
    AppStore?: any;
}

@inject('AppStore')
@observer

export default class TitleDescription extends React.Component<Features> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <div className="text-center my-7">
                <h2 className="text-5xl font-bold">{this.props.title}</h2>

                {
                    this.props.description !== undefined &&
                    <p className="mt-2">{this.props.description}</p>
                }
            </div>
        )
    }
}